"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleEditorWhen = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const DatePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker"));
const TimePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker/TimePicker"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const RepetitionTypePicker_1 = __importDefault(require("./RepetitionTypePicker"));
const TimeDiffPicker_1 = __importDefault(require("./TimeDiffPicker"));
const OpScheduleEditorWhen = function (props) {
    const { opSchedule, onChange } = props;
    const { dueDate, whenCanView, whenCanStart, whenIsMissed } = opSchedule;
    const visibleInvalid = opSchedule.whenCanStart > opSchedule.whenCanView;
    const [dueDateDate, setDueDateDate] = (0, react_1.useState)((0, moment_timezone_1.default)(dueDate));
    const [dueDateTime, setDueDateTime] = (0, react_1.useState)((0, moment_timezone_1.default)(dueDate));
    const handleChange = (0, useCallforward_1.default)(field => value => onChange({ [field]: value }), [onChange]);
    const handleChangeDueDateDate = (0, react_1.useCallback)(value => {
        if (value.isValid()) {
            value
                .hours(dueDate.hours())
                .minutes(dueDate.minutes())
                .seconds(dueDate.seconds())
                .milliseconds(dueDate.milliseconds());
            setDueDateTime(value);
            onChange({ dueDate: value });
        }
        setDueDateDate(value);
    }, [onChange, dueDate]);
    const handleChangeDueDateTime = (0, react_1.useCallback)(value => {
        if (value.isValid()) {
            value.year(dueDate.year()).month(dueDate.month()).day(dueDate.day());
            setDueDateDate(value);
            onChange({ dueDate: value });
        }
        setDueDateTime(value);
    }, [onChange, dueDate]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Text_1.default, { variant: "h2" }, lib_i18n_1.default.t('due')),
                react_1.default.createElement(Horizontal_1.default, null,
                    react_1.default.createElement(DatePicker_1.default, { timezone: 'UTC', noMargin: true, value: dueDateDate, onChange: handleChangeDueDateDate }),
                    react_1.default.createElement(TimePicker_1.default, { timezone: 'UTC', noMargin: true, value: dueDateTime, onChange: handleChangeDueDateTime }))),
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Text_1.default, { variant: "h2" }, lib_i18n_1.default.t('repeats')),
                react_1.default.createElement(RepetitionTypePicker_1.default, { schedule: opSchedule, onChange: onChange })),
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement("ul", null,
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(Text_1.default, null,
                            lib_i18n_1.default.t('can-be-started') + ' ',
                            react_1.default.createElement(TimeDiffPicker_1.default, { noMargin: true, noBorder: true, value: whenCanStart, onChange: handleChange('whenCanStart') }),
                            ' ' + lib_i18n_1.default.t('before-due'))),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(Text_1.default, { color: visibleInvalid ? 'error' : undefined },
                            lib_i18n_1.default.t('visible-in-todo') + ' ',
                            react_1.default.createElement(TimeDiffPicker_1.default, { noMargin: true, noBorder: true, value: whenCanView, onChange: handleChange('whenCanView') }),
                            ' ' + lib_i18n_1.default.t('before-due'))),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(Text_1.default, null,
                            lib_i18n_1.default.t('missed-if-not-submitted') + ' ',
                            react_1.default.createElement(TimeDiffPicker_1.default, { noMargin: true, noBorder: true, value: whenIsMissed, onChange: handleChange('whenIsMissed') }),
                            ' ' + lib_i18n_1.default.t('after-due'))))))));
};
exports.OpScheduleEditorWhen = OpScheduleEditorWhen;
exports.default = exports.OpScheduleEditorWhen;
